import {
  Contribution,
  ContributionClassName,
  ContributionsListItem,
} from 'types/contribution';
import {
  deleteSongContributionEffect,
  deleteSongContributorEffect,
} from 'app/store/SongList/effects';
import { useState } from 'react';
import { AppDispatch } from 'app/store';

export const useContributionsListState = (dispatch: AppDispatch) => {
  const handleContributorDelete = (contributions: Partial<Contribution>[]) => {
    dispatch(deleteSongContributorEffect({ contributions }));
  };

  const handleDeleteContribution = (guid: string) => {
    dispatch(deleteSongContributionEffect({ guid }));
  };

  const [dialogOpen, setDialogOpen] = useState<{
    type: 'delete' | 'contributionsList';
    contributionClassName: ContributionClassName;
    contributor: ContributionsListItem;
  }>();

  return {
    handleContributorDelete,
    handleDeleteContribution,
    setDialogOpen,
    dialogOpen,
  };
};
